export const baseUrl = process.env.REACT_APP_API_ENDPOINT;
/* We removed the ternary to resolve deployment issues.
You now need to pass the api endpoint manually as an environment variable.

Feel free to copy/paste the line below in your terminal :

REACT_APP_API_ENDPOINT="http://15.188.66.181:1337" npm run start

REACT_APP_API_ENDPOINT="https://apipreprod.wixar.io" npm run start
*/
const apiUrls = {
  base: baseUrl,
  getWixarLauncherUris: `${baseUrl}/api/custom/getWixarLauncherUrls`,
  getEditorWebLastCommit: `${baseUrl}/custom/getLastEditorWebCommitHash`,
  sseStream: `${baseUrl}/api/event/sse`,
  register: {
    organization: `${baseUrl}/api/organizations`,
    users: `${baseUrl}/api/users`,
    deleteCreator: `${baseUrl}/api/users-permissions/custom/deleteCreator`,
    deleteCreators: `${baseUrl}/api/users-permissions/custom/deleteCreators`,
    deleteEnduser: `${baseUrl}/api/users-permissions/custom/deleteEnduser`,
    deleteEndusers: `${baseUrl}/api/users-permissions/custom/deleteEndusers`,
  },
  auth: {
    signIn: `${baseUrl}/api/auth/creator`,
    checkPwd: `${baseUrl}/api/users-permissions/auth/checkPwd`,
    checkEmail: `${baseUrl}/api/users/checkemail`,
    forgetPassword: `${baseUrl}/api/auth/forgot-password`,
    resetPassword: `${baseUrl}/api/auth/reset-password`,
    changePasswordFromProfile: `${baseUrl}/api/auth/change-password`,
    generateVrStudioJwt: `${baseUrl}/api/auth/convertJwt`,
  },
  contents: `${baseUrl}/api/contents`,
  builds: `${baseUrl}/api/builds`,
  themeInfos: `${baseUrl}/api/theme-infos`,
  languages: `${baseUrl}/api/languages`,
  projects: {
    projectTags: `${baseUrl}/api/project-tags`,
    all: `${baseUrl}/api/projects`,
    translateProject: `${baseUrl}/api/projects/translations`,
    multipleProjects: `${baseUrl}/api/custom/project/multiple`,
    askPublication: `${baseUrl}/api/custom/askPublication`,
    retryPublication: `${baseUrl}/api/custom/retryPublication`,
    allWithUserTemplates: `${baseUrl}/api/custom/projectsWithUserTemplates`,
    clone: `${baseUrl}/custom/clone`,
    duplicateProject: `${baseUrl}/api/custom/duplicateProject`,
    duplicateProjectGroup: `${baseUrl}/api/project-groups/duplicateProjectGroupUserRoute`,
    cloneTemplate: `${baseUrl}/custom/makeTemplate`,
    templates: `${baseUrl}/api/template-overviews`,
    createScene: `${baseUrl}/api/custom/createScene`,
    copySceneToProject: `${baseUrl}/api/custom/copySceneToProject`,
    unlinkedScenes: `${baseUrl}/api/custom/unlinkedScenes`,
    contens: {
      contentType: `${baseUrl}/content-types`,
    },
    getMetaDatas: `${baseUrl}/api/projects/metadata`,
    deleteNode: `${baseUrl}/api/projects/deleteNode`,
    graph: {
      sessions: `${baseUrl}/sessions`,
      flat: `${baseUrl}/api/projects/full`,
    },
    projectLanguageDatas: `${baseUrl}/api/project-language-data`,
    projectUserPermissions: `${baseUrl}/api/project-user-permissions`,
    inviteExternalUser: `${baseUrl}/custom/inviteExternalUser`,
    inviteEnduser: `${baseUrl}/api/users-permissions/custom/inviteEnduser`,
    inviteEnduserWithoutProject: `${baseUrl}/custom/inviteEnduserWithoutProject`,
    bulkInviteEndusersWithoutProject: `${baseUrl}/api/custom/bulkInviteEndusersWithoutProject`,
    inviteExternalCreatorToOrg: `${baseUrl}/api/users-permissions/custom/inviteExternalCreatorToOrg`,
    inviteExistingUser: `${baseUrl}/api/users-permissions/custom/invite`,
    getEnduser: `${baseUrl}/custom/endusersPerProject`,
    nuSendResults: `${baseUrl}/custom/nuSendResults`,
    nuSendGlobalResults: `${baseUrl}/custom/nuSendGlobalResults`,
    getContentScoringGeneralCount: `${baseUrl}/custom/getContentScoringGeneralCount`,
    projectGroups: `${baseUrl}/api/project-groups`,
    multipleProjectGroups: `${baseUrl}/api/project-groups/multiple`,
    projectGroupElements: `${baseUrl}/api/project-group-elements`,
    projectGroupsWithProjects: `${baseUrl}/api/custom/projectGroupsWithProjects`,
    reorderProjects: `${baseUrl}/api/custom/reorderProjects`,
    projectSize: `${baseUrl}/api/getSizeOf/project`,
    projectGroupSize: `${baseUrl}/api/getSizeOf/projectGroup`,
    projectTranslations: `${baseUrl}/api/projects/translations`,
    searchIndex: `${baseUrl}/api/project-groups/searchIndex`,
  },
  medias: {
    all: `${baseUrl}/api/source-medias`,
    generateAudio: `${baseUrl}/api/custom/tts`,
    initializeMultipart: `${baseUrl}/api/custom/upload/initializeMultipart`,
    askForPublicationOf3DEnvironment: `${baseUrl}/api/custom/upload/askForPublicationOf3DEnvironment`,
    getSignedPartUploadLink: `${baseUrl}/api/custom/upload/getSignedPartUploadLink`,
    completeMultipartUpload: `${baseUrl}/api/custom/upload/completeMultipartUpload`,
    addMediaToDatabase: `${baseUrl}/api/custom/upload/addMediaToDatabase`,
    transcribeMedia: `${baseUrl}/api/custom/upload/transcribePdf`,
    addTagstoDatabase: `${baseUrl}/api/custom/tags/addTagsToDatabase`,
    getTagsOrganization: `${baseUrl}/api/tags`,
    checkIfMediasAreUsed: `${baseUrl}/api/custom/checkExistAll`,
    deleteMultipleMedias: `${baseUrl}/api/custom/deleteMultipleMedia`,
    blockadeLabs: {
      models: `${baseUrl}/api/blockadeLabs/models`,
      generate: `${baseUrl}/api/blockadeLabs/generate`,
      addBlockadeImageToDatabase: `${baseUrl}/api/custom/upload/addBlockadeImageToDatabase`,
    },
    elevenLabs: {
      fetchVoices: `${baseUrl}/api/custom/ttsVoices`,
    },
    uploadAvatar: `${baseUrl}/api/custom/upload/uploadAvatar`,
    updateAvatarVoices: `${baseUrl}/api/custom/upload/updateAvatarVoices`,
    duplicateAvatar: `${baseUrl}/api/custom/upload/duplicateAvatar`,
    searchIndex: `${baseUrl}/api/source-medias/searchIndex`,
    download: `${baseUrl}/api/source-medias/download`,
    securedMedias: `${baseUrl}/api/custom/securedMedias`,
  },
  csv: {
    add: `${baseUrl}/api/users-permissions/custom/addEndusersCsv`,
  },
  teamForAdmin: `${baseUrl}/api/users-permissions/custom/getOrgMembersWithPermissions`,
  creatorWantPublish: `${baseUrl}/custom/creatorWantPublish`,
  getMostRecentEditorVrBuildPerPlatform: `${baseUrl}/custom/getMostRecentEditorVrBuildPerPlatform`,
  getDesktopAgentDownloadUrl: `${baseUrl}/custom/getDesktopAgentDownloadUrl`,
  userErrorTraces: `${baseUrl}/api/user-error-traces`,
  inviteWithoutEmail: `${baseUrl}/api/users-permissions/custom/inviteSimplifiedEnduser`,
  stats: {
    getAllSessionsByProject: `${baseUrl}/api/scores/projectsSessions`,
    getAllSessionsByProjectGroup: `${baseUrl}/api/scores/projectGroupsSessions`,
    successRatePerScene: `${baseUrl}/api/scores/successRatePerScene`,
    interactionStats: `${baseUrl}/api/scores/interactionStats`,
    successRatePerProjectGroup: `${baseUrl}/api/scores/averageSuccessRatePerProjectGroup`,
    enduserStatsPerProject: `${baseUrl}/api/scores/enduserStatsPerProject`,
    sendProjectResults: `${baseUrl}/custom/nuSendResults`,
    sendGlobalResults: `${baseUrl}/api/scores/sendGlobalResults`,
    getGlobalResultsDownloadLink: `${baseUrl}/api/scores/globalResultsDownloadLink`,
    enduserProjectGroupsCompletionSortedByLatestSession: `${baseUrl}/api/scores/enduserProjectGroupsCompletionSortedByLatestSession`,
    enduserSessionDetailsForGivenProject: `${baseUrl}/api/scores/enduserSessionDetailsForGivenProject`,
    enduserProjectGroupCompletion: `${baseUrl}/api/scores/enduserProjectGroupCompletion`,
    enduserStatsOverview: `${baseUrl}/api/scores/enduserStatsOverview`,
    enduserAllSessions: `${baseUrl}/api/scores/enduserAllSessions`,
    sessionSubdatas: `${baseUrl}/api/scores/sessionSubdatas`,
    interactionAttempts: `${baseUrl}/api/scores/interactionAttempts`,
    gazeHeatmapData: `${baseUrl}/api/scores/gazeHeatmapData`,
    sceneGazeHeatmapData: `${baseUrl}/api/scores/sceneGazeHeatmapData`,
    gazeHeatmapCheck: `${baseUrl}/api/scores/gazeHeatmapCheck`,
    enduserInteractionStats: `${baseUrl}/api/scores/enduserInteractionStats`,
    enduserScorePerScene: `${baseUrl}/api/scores/enduserScorePerScene`,
    contentSpecificData: `${baseUrl}/api/scores/contentSpecificData`,
    gptConversationData: `${baseUrl}/api/scores/gptConversationData`,
    enduserProjectGroupBuilds: `${baseUrl}/api/scores/enduserProjectGroupBuilds`,
    enduserAllApkBuilds: `${baseUrl}/api/scores/enduserAllApkBuilds`,
    projectGroupMediaManifest: `${baseUrl}/api/scores/projectGroupMediaManifest`,
  },
  admin: {
    userDetails: `${baseUrl}/api/users-permissions/custom/userDetails`,
    inviteCreatorWithPerms: `${baseUrl}/api/users-permissions/custom/inviteCreatorWithPerms`,
    inviteEnduserWithPerms: `${baseUrl}/api/users-permissions/custom/inviteEnduserWithPerms`,
    editCreatorPerms: `${baseUrl}/api/users-permissions/custom/editCreatorPerms`,
    editEnduserPerms: `${baseUrl}/api/users-permissions/custom/editEnduserPerms`,
  },
  buildShare: {
    generateShareToken: `${baseUrl}/api/builds/generate-share-token`,
    shareLinks: `${baseUrl}/api/builds/share-links`,
    sendEmail: (linkId: number | string) =>
      `${baseUrl}/api/builds/share-links/${linkId}/send-email`,
    eligibleEndusers: (linkId: number | string) =>
      `${baseUrl}/api/builds/share-links/${linkId}/eligible-endusers`,
  },
  paEmbedLinks: `${baseUrl}/api/billing/paEmbedLinks`,
  anonymousSessionsCount: `${baseUrl}/api/billing/anonymousSessionsCount`,
  getSubscriptionState: `${baseUrl}/api/subscriptionFeatures/getSubscriptionState`,
  userOpenedTutorial: `${baseUrl}/api/user-opened-tutorials`,
  userOpenedTutorialReset: `${baseUrl}/api/user-opened-tutorials/reset`,
  legals: `${baseUrl}/api/legals/urls`,
  moodle: {
    moodleEnv: `${baseUrl}/api/moodle-envs`,
    generate: `${baseUrl}/api/moodle/generate`,
    revoke: `${baseUrl}/api/moodle/revoke`,
  },
  gpt: {
    createChat: `${baseUrl}/api/gpt/createChat`,
    updateChat: `${baseUrl}/api/gpt/updateChat`,
    resetChat: `${baseUrl}/api/gpt/resetChat`,
    askWixarpedia: `${baseUrl}/api/gpt/askWixarpedia`,
    gptConversations: `${baseUrl}/api/gpt-conversations`,
    generateTemplate: `${baseUrl}/api/gpt/generateTemplate`,
    findAllWithNestedStuff: `${baseUrl}/api/gpt/findAllWithNestedStuff`,
    planMode: {
      start: `${baseUrl}/api/gpt/plan-mode/start`,
      continue: `${baseUrl}/api/gpt/plan-mode/continue`,
      transitionToReady: `${baseUrl}/api/gpt/plan-mode/transition-to-ready`,
      refine: `${baseUrl}/api/gpt/plan-mode/refine`,
      generate: `${baseUrl}/api/gpt/plan-mode/generate`,
    },
  },
  slopify: `${baseUrl}/api/slopify`,
  slopifyPropagate: `${baseUrl}/api/slopify/propagate`,
  contentFieldSchemas: `${baseUrl}/api/content-field-schemas`,
  rag: {
    agents: `${baseUrl}/api/rag/agents`,
    documents: `${baseUrl}/api/rag/documents`,
  },
  voiceMode: {
    azureToken: `${baseUrl}/api/voice-mode/azure-token`,
    elevenlabsToken: `${baseUrl}/api/voice-mode/elevenlabs-token`,
  },
};

export default apiUrls;
